import type { UserProgress } from "@/Modules/Models/Domain/User";

import { getMeProgress } from "@/Services/TherapyApi/Users";

import useUserStore from "../Store";

import UserProgressTransformer from "@/Modules/Transformers/User/UserProgress";

import { hasValue } from "@/Utils/Objects";

async function getProgressActionHandler(): Promise<UserProgress | null> {
  const userStore = useUserStore();

  if (hasValue(userStore.user)) {
    const progress = await getMeProgress();

    userStore.progress = UserProgressTransformer.toDomain(progress);
  } else {
    userStore.progress = null;
  }

  return userStore.progress;
}

export default getProgressActionHandler;
